import { Injectable, inject } from '@angular/core';

import { BaseSignalQuery } from '../signal-state.util';

import { PermissionState, PermissionStore } from './permission.store';

@Injectable({ providedIn: 'root' })
export class PermissionQuery extends BaseSignalQuery<PermissionState> {
  constructor() {
    const store = inject(PermissionStore);
    super(store);
  }
}
